const AXIOS_DEFAULT_CONFIG = {
	baseURL: process.env['NEXT_PUBLIC_HOST'],
	timeout: 1000 * 60,
	withCredentials: true,
};

export { AXIOS_DEFAULT_CONFIG };
